import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AssumedRoleStoreService } from 'src/app/services/assumed-role-store.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { BusinessEntityService } from 'src/app/services/business-entity.service';
import { LookupService } from 'src/app/services/lookup.service';

@Component({
  selector: 'app-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrl: './navigation-bar.component.css'
})
export class NavigationBarComponent {
  loginUserName = ''
  employeeId: number
  loginUserRole = ''
  selectedAssume = ''
  mainAssumeIdentity = []
  inputAssume: any
  assumeSelect = null
  assumeEmployeeId: any
  assumed = false
  assumeStringify: any
  reportIssueUrl = "https://tmna.service-now.com/1ts?id=1ts_cat_item&sys_id=0f627bb7db3db240ad1d7eb6bf96197b"
  displayNavBar: boolean;
  validation: any;
  adminAccess: boolean;
  showErrorMsg = false;
  errorMessage = '';

  constructor(private readonly lookup: LookupService, private readonly ngxSpinner: NgxSpinnerService, private readonly router: Router,
    private readonly bservice: BusinessEntityService, private readonly assumeRole: AssumedRoleStoreService, public authentService:AuthenticationService,
    private readonly route: Router
  ) {}

  ngOnInit() {
    this.validation=this.lookup.localStorageData.subscribe(data=>{
      if(data?.includes('success')){
        this.employeeId=this.bservice.loggedUserEmployeeId;
        this.displayNavBar=true;
        this.loginUserName = this.bservice.loggedUserEmployeenameOriginal;
        const localStorageAssumeUser= JSON.parse(localStorage.getItem('userAssumed'));
        if(localStorageAssumeUser){
          this.assumeRole.assumeRoleByLocalStorage(localStorageAssumeUser)
          this.loginUserRole = this.assumeRole.loginUserRole
          this.adminAccess = this.assumeRole.isAdmin
        }else{
          this.assumeRole.assumeRoleByBService()
          this.loginUserRole = this.assumeRole.loginUserRole
          this.adminAccess = this.assumeRole.isAdmin
        }
        if(localStorageAssumeUser!=="undefined" && localStorageAssumeUser!==null ){
          this.selectedAssume=localStorageAssumeUser.pdkusername
          this.assumed=true;
        }
      } else {
        this.displayNavBar = false;
      }
    })
    
    this.adminAccess = this.assumeRole.isAdmin
    this.loginUserRole = this.assumeRole.loginUserRole
  }

  callAssumeIdentity() {
    this.ngxSpinner.show()
    this.lookup.getAssumeIdentityList(this.employeeId,this.loginUserRole).subscribe(data=>{
      if(data['statusCode'] === 200 && !data.body.errorResponse){
        this.mainAssumeIdentity=data.body.response;
        this.ngxSpinner.hide();
      } else{
        this.ngxSpinner.hide();
      }
    })
  }

  get assumeIdentity(): any[] {
    if (!this.inputAssume || this.inputAssume.trim().length === 0) {
      return this.mainAssumeIdentity;
    }
    const searchValue = this.inputAssume.toLowerCase();
    return this.mainAssumeIdentity.filter(value => value.pdkusername.toLowerCase().includes(searchValue));
  }

  selectAssume(assume:any,employeeid:any,assumeStringify:any){
    this.assumeSelect=assume;
    this.assumeEmployeeId=employeeid;
    this.assumeStringify=assumeStringify;
  }

  assume(){
    localStorage.setItem("assumeClicked", "true");
    localStorage.setItem("userAssumed",JSON.stringify(this.assumeStringify));
    localStorage.setItem("assumedPath",this.router.url);
    localStorage.setItem("redirectedAssume",'false');
    location.reload();
  }

  callFaqUrl(){
    this.ngxSpinner.show();
    this.lookup.getReportPeriod().subscribe({
      next: (res) => {
        this.openFaqPage(res.body.response[0]?.unionreportperiodid);
      },
      error: (err) => {
        if (err) { 
          this.ngxSpinner.hide() 
        };
      }
    });
  }

  openFaqPage(reportPeriod){
    this.ngxSpinner.show();
    this.lookup.getreportPeriodInfo(reportPeriod).subscribe({
      next: (data) => {
        this.ngxSpinner.hide();
        if (data?.body[0]) {
          if(data?.body[0]?.faqspath) {
            const a = document.createElement('a');
            a.setAttribute("href", data.body[0].faqspath);
            a.setAttribute("target", "_blank");
            a.click();
            this.route.navigateByUrl('/home');
          } else {
            this.errorMessage = 'FAQ path not found for current report period. Please update path in Admin tab to redirect.'
            this.showErrorMsg = true;
            setTimeout(()=>{
              this.showErrorMsg = false;
            },5000);
          }
        } else {
          this.errorMessage = 'Unable to fetch FAQ path details.'
          this.showErrorMsg = true;
          setTimeout(()=>{
            this.showErrorMsg = false;
          },5000);
        }
        window.scroll(0,0);
      },
      error: (err) => {
        if (err) {
          this.errorMessage = 'Unable to fetch FAQ path details.'
          this.showErrorMsg = true;
          setTimeout(()=>{
            this.showErrorMsg = false;
          },5000);
          this.ngxSpinner.hide();
          window.scrollTo(0, 0);
        }
      }
    });
  }

  cancelAssume(){
    this.assumed=false; 
    this.assumeSelect=null;
    this.selectedAssume=''
    localStorage.clear();
    this.bservice.loggedUserEmployeeId=this.bservice.loggedUserEmployeeIdOriginal;
    sessionStorage.removeItem("assumeUsername");
    sessionStorage.removeItem("assumeIsmanagement");
    sessionStorage.removeItem("assumePermissions");
    sessionStorage.removeItem("assumePurchasinggroupid");
    location.reload();  
  }

  reportIssue(){
    window.open(this.reportIssueUrl, '_blank')
  }

  closeDialog(){
    this.assumeSelect=null;
    this.inputAssume='';
  }

  logout(){
    localStorage.clear();
    window.history.pushState({},document.title,'');
    sessionStorage.clear();
    this.authentService.logout();
  }
  ngOnDestroy(){
    this.validation.unsubscribe();
  }
}
